module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '' && _vm.subpage == 'open') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Kitöltési útmutató")]), _vm._v(" "), _c('PerfectScrollbar', {
    staticStyle: {
      "height": "50vh",
      "border": "1px solid #f4f4f4",
      "padding": "20px 20px 0px 20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "options": {
        wheelPropagation: false,
        handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']
      }
    }
  }, [_c('div', {
    staticClass: "article-text medium"
  }, [_c('p', [_vm._v("Tisztelt ösztöndíjasok!")]), _vm._v(" "), _c('p', [_vm._v("Az Új Nemzeti Kiválóság Program (továbbiakban: ÚNKP) keretein belül a Pályázati Kiírásoknak megfelelően minden ösztöndíjas számára kötelező a kutatási időszaka végén a pályázatában vállalt kutatásáról "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai Záró Beszámolót")]), _vm._v(" (továbbiakban: Beszámoló) és annak részeként "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Témavezetői Szakmai Értékelést")]), _vm._v(" (továbbiakban: Értékelés) benyújtania a megfelelő igazolásokkal együtt.")]), _vm._v(" "), _c('p', [_vm._v("A Beszámoló és az Értékelés sablonjait a "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("KTR")]), _vm._v(" rendszerbe (ktr.sze.hu) belépve tudják letölteni.")]), _vm._v(" "), _c('p', [_vm._v("A Beszámolót intézményünk ÚNKP bíráló bizottsága fogja értékelni Kiváló, Megfelelt és Nem megfelelt minősítéssel.")]), _vm._v(" "), _c('p', [_vm._v("A Nem megfelelt minősítést kapott ösztöndíjasok kötelesek a korábban megkapott ösztöndíjukat a Széchenyi István Egyetemnek visszafizetni. (ld. Pályázati Kiírások).")]), _vm._v(" "), _c('p', [_vm._v("A "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("KTR-be")]), _vm._v(" legyenek kedvesek legkésőbb "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("2020. február 3-án")]), _vm._v(" "), _c('u', [_vm._v("véglegesíteni")]), _vm._v(" a Beszámolójukat, illetve "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("2020. február 4-én 11-óráig")]), _vm._v(" az Igazgatási Épület (SZE Győr) 209-es irodájában "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("papír alapon")]), _vm._v(" leadni az aláírt "), _c('u', [_vm._v("Beszámolót, Értékelést, Konzultációs lapot")]), _vm._v(" és a Beszámolóhoz tartozó összes eredeti igazolást, publikációt, mellékletet.")]), _vm._v(" "), _c('p', [_vm._v("Kitöltési segédlet:")]), _vm._v(" "), _c('ul', {
    staticClass: "ordered-list with-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A Beszámolókból legyen kedves a pályázatakor megadott kategória szerinti sablont választani.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Az Értékelést – a fejlécet kitöltve – legyen kedves eljuttatni a témavezetőjéhez és azt a Beszámoló részeként kitöltve feltölteni a KTR rendszerbe.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Az 1-5 pontot legyen kedves kifejteni, de a Beszámoló teljes terjedelme ne legyen több 2-3 oldalnál.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A 2/a. pontnál legyen kedves nyilatkozni, hogy az ÚNKP intézményi kerete terhére történt-e költségelszámolás, mi volt az, hogyan használta fel az ÚNKP kutatás során (1mondat), ill. amennyiben releváns a beszerzésre került anyagok/eszközök Egyetemi leltárba kerültek vagy fogyóeszköznek minősültek (a nem kívánt rész törlendő – ha nem volt ezirányú beszerzése az egész mondat).")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A 6. pontban az intézményen belüli kötelező vállalásokról nyilatkozik, kérem, ne javítsa a sablon szövegét. Az ÚNKP Tanulmánykötet terveink szerint 2020. június 30-a előtt fog megjelenni, ill. az ÚNKP konferenciákat 2020 áprilisában szeretnénk megtartani.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("7. pontnál legyen kedves minden cellát kitölteni, a 0-ákat is beírva.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A keltezési időpontokat legyen kedves változatlanul hagyni a Beszámolón és az Értékelésen is.")])]), _vm._v(" "), _c('p', [_vm._v("Köszönettel és üdvözlettel,\n            "), _c('br'), _vm._v("ÚNKP felelős\n          ")])])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.subpage = 'data'
      }
    }
  }, [_vm._v("Tovább")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.fill_info == '' && _vm.subpage == 'data') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "mobilszam",
      "label": "Mobilszám",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+",
      "name": "mobilszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.mobilszam),
      callback: function($$v) {
        _vm.form.mobilszam = $$v
      },
      expression: "form.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "szakmai_zaro_beszamolo_szerkesztheto",
      "label": "Szakmai Záró Beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló_szerk. legyen.)</span>",
      "name": "szakmai_zaro_beszamolo_szerkesztheto",
      "loaded_files": _vm.form.szakmai_zaro_beszamolo_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.szakmai_zaro_beszamolo_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szakmai_zaro_beszamolo",
      "label": "Szakmai Záró Beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló legyen.)</span>",
      "name": "szakmai_zaro_beszamolo",
      "loaded_files": _vm.form.szakmai_zaro_beszamolo
    },
    on: {
      "change": function (value) {
        _vm.form.szakmai_zaro_beszamolo = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "temavezetoi_szakmai_ertekeles_szerkesztheto",
      "label": "Témavezetői Szakmai Értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés_szerk. legyen.)</span>",
      "name": "temavezetoi_szakmai_ertekeles_szerkesztheto",
      "loaded_files": _vm.form.temavezetoi_szakmai_ertekeles_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.temavezetoi_szakmai_ertekeles_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "temavezetoi_szakmai_ertekeles",
      "label": "Témavezetői Szakmai Értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés legyen.)</span>",
      "name": "temavezetoi_szakmai_ertekeles",
      "loaded_files": _vm.form.temavezetoi_szakmai_ertekeles
    },
    on: {
      "change": function (value) {
        _vm.form.temavezetoi_szakmai_ertekeles = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "konzultacios_lap",
      "label": "Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Konzultációs lap legyen.)</span>",
      "name": "konzultacios_lap",
      "loaded_files": _vm.form.konzultacios_lap
    },
    on: {
      "change": function (value) {
        _vm.form.konzultacios_lap = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "kutatasi_terv",
      "label": "Kutatási terv aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A pályázat beadásakor (alapképzés esetén szeptemberben) leadott eredeti, aláírt Kutatási Terv), (A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Kutatási terv legyen.)</span>",
      "name": "kutatasi_terv",
      "loaded_files": _vm.form.kutatasi_terv
    },
    on: {
      "change": function (value) {
        _vm.form.kutatasi_terv = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "10",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "mellekletek",
      "label": "Mellékletek <span style='font-size: 10px; display: block; font-weight: 400'>(A melléklet elnevezése, száma a Szakmai Záró Beszámoló pontjai szerint. Doktori hallgatói-, doktorjelölt kategóriánál az MTMT lista kötelező melléklet. A 6. pont teljesítését központilag az Intézményi Szakmai Beszámolóban fogjuk igazolni.)</span>",
      "name": "mellekletek",
      "loaded_files": _vm.form.mellekletek
    },
    on: {
      "change": function (value) {
        _vm.form.mellekletek = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.form.melleklet_urlek), function(url, i) {
    return _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "margin-bottom": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.melleklet_urlek[i]),
        expression: "form.melleklet_urlek[i]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
      },
      domProps: {
        "value": (_vm.form.melleklet_urlek[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.form.melleklet_urlek,
            $$idx = i;
          if (!Array.isArray($$exp)) {
            _vm.form.melleklet_urlek[i] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button only-icon v2",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "href": _vm.form.melleklet_urlek[i],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "button only-icon",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteUrl(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_melleklet_url),
      expression: "uj_melleklet_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
    },
    domProps: {
      "value": (_vm.uj_melleklet_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uj_melleklet_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button only-icon v2",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(2)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP Szakmai Záró Beszámoló")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/szakmai_zaro_beszamolo_sablon_alapkepzes_tehetseggel_fel.docx",
      "title": "Szakmai záró beszámoló alapképzés sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai záró beszámoló alapképzés sablon")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/szakmai_zaro_beszamolo_sablon_mester(osztatlan)_kepzes.docx",
      "title": "Szakmai záró beszámoló mester (osztatlan) sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai záró beszámoló mester (osztatlan) sablon")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/szakmai_zaro_beszamolo_sablon_doktori_hallgato_doktorjelolt.docx",
      "title": "Szakmai záró beszámoló doktori hallgató, doktorjelölt sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai záró beszámoló doktori hallgató, doktorjelölt sablon")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/temavezetoi_szakmai_ertekeles_sablon.docx",
      "title": "Témavezetői szakmai értékelés sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Témavezetői szakmai értékelés sablon")]), _vm._v(" letöltés\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-127b21c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/unkp_beszamolo.vue
// module id = 330
// module chunks = 0